<template>
  <Container type="card-full">
    <div slot="header">
      <el-button type="primary" v-if="type === 1 || type === 2" @click="save" :loading="btnLoading">保存</el-button>
      <!-- <el-button @click="close">关闭</el-button> -->
    </div>
    <div class="main">
      <el-form :model="dac" ref="ruleForm" label-position="right" class="mainfrom from_input">
       <div class="row">
            <el-form-item label="名称" prop="dacname" :verify="validateUsercode">
              <el-input v-model.trim="dac.dacname" :maxlength="20" :disabled="disable"></el-input>
            </el-form-item>
       </div> 
        <div class="content">
            <el-form-item label="部门" prop="dacdptid" :verify="validateDpt">
              <!--&& $store.getters.loginUser.adminflag-->
              <el-select v-model="dac.dacdptid" placeholder="请选择">
                <el-option v-for="item in dacdptList" :key="item.dptid" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
        </div>
        <div class="content">
            <el-form-item label="备注">
              <el-input v-model="dac.dacremark" type="textarea" :maxlength="255" show-word-limit :disabled="disable"></el-input>
            </el-form-item>
        </div>
      </el-form>
        <vxe-toolbar  perfect>
            <template v-slot:buttons>
              <vxe-button icon="vxe-icon--plus" status="perfect" v-if="type === 1 || type === 2" @click="addUser">添加</vxe-button>
            </template>
        </vxe-toolbar>
      <vxe-table
        border
        :data="dacitems">
        <vxe-table-column type="index" title="行号" width="60"></vxe-table-column>
        <vxe-table-column field="usercode" title="账号"></vxe-table-column>
        <vxe-table-column field="username" title="姓名"></vxe-table-column>
        <vxe-table-column field="dptname" title="部门"></vxe-table-column>
        <vxe-table-column field="" title="权限">
          <template slot-scope="scope">
            <div  v-if="type === 1 || type === 2">
              <el-checkbox  v-model="scope.row.comchecked" :disabled="disable">单位管理员</el-checkbox>
              <el-checkbox v-model="scope.row.dptchecked" :disabled="disable">部门管理员</el-checkbox>
            </div>
            <div v-else>
              <span v-if="scope.row.comchecked"><el-tag>单位管理员</el-tag></span>
              <span v-if="scope.row.dptchecked"><el-tag>部门管理员</el-tag></span>
              <span v-if="!scope.row.comchecked && !scope.row.dptchecked"><el-tag>职员</el-tag></span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="" title="操作" v-if="type === 1 || type === 2">
          <template slot-scope="scope">
            <vxe-button icon="el-icon-delete" title="删除"  @click="delUser(scope.row)" circle></vxe-button>
            <!-- <el-button @click="delUser(scope.row)">删除</el-button> -->
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <el-dialog :close-on-click-modal="false" @close="closeDialog"  title="选择" :visible.sync="dialogVisible" width="80%">
      <div>
        <div class="search">
          <div class="search_box">
            <div class="searchItem">
              <div class="label">账号</div>
              <div class="field">
                <el-input v-model.trim="query.usercode" clearable></el-input>
              </div>
            </div>
            <div class="searchItem">
              <div class="label">姓名</div>
              <div class="field">
                <el-input v-model.trim="query.username" clearable></el-input>
              </div>
            </div>
            <div class="searchItem">
              <div class="label">部门</div>
              <div class="field">
                <el-select v-model="query.userdptid" :clearable="true" placeholder="请选择">
                  <el-option v-for="item in dptList"  :key="item.index" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="searchItem">
              <div class="search_btn">
                <el-button type='primary' @click="getList">查询</el-button>
                <el-button type='primary' @click="submit">提交</el-button>
              </div>
            </div>
          </div>
        </div>
        <vxe-table
          border
          :data="list" ref="xGrid">
          <vxe-table-column
            type="selection"
            width="55">
          </vxe-table-column>
          <vxe-table-column type="index" title="行号" width="60"></vxe-table-column>
          <vxe-table-column field="usercode" title="账号"></vxe-table-column>
          <vxe-table-column field="username" title="姓名"></vxe-table-column>
          <vxe-table-column field="dptname" title="部门"></vxe-table-column>
          <!--<vxe-table-column field="" title="权限">-->
          <!--<template slot-scope="scope">-->
          <!--<el-checkbox  v-model="scope.row.comchecked" :disabled="disable">单位管理员</el-checkbox>-->
          <!--<el-checkbox v-model="scope.row.dptchecked" :disabled="disable">部门管理员</el-checkbox>-->
          <!--</template>-->
          <!--</vxe-table-column>-->
        </vxe-table>
      </div>
    </el-dialog>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  import common from '@/mixin/common'
  import _ from 'lodash'
  const SUCCESS  = 1
  export default {
    name: "dacform",
    mixins: [common],
    data () {
      return {
        dialogVisible: false,
        query: {},
        dac: {
          dacname: '',
          dacremark: ''
        },
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        list: [],
        dacitems: [],
        dptList: [],
        dacdptList:[],
        btnLoading: false,
        multipleSelection: []
      }
    },
    created () {
      this.dialogVisible= false
    },
    activated () {
      this.type = Number(this.$route.params.type)
      this.disable = this.$route.params.type === 3 ? true : false
      this.dac = this.$route.params.form
      this.list = []
      this.dialogVisible= false
      this.getDacItems()
      this.getDptList()
    },
    watch: {
    },
    filters: {
    },
    components: {vggrid},
    methods: {
      closeDialog () {
        this.dialogVisible = false
      },
      validateDpt(rul, val, callback){
        console.log('-------val---------',this.dac);
          this.validateData('部门已存在', 'dacrec', 'dacid', 'dacdptid', this.dac.dacdptid,"","", callback)
      },
      validateData (msg, tablename, fieldid, checkfield, checkval,fieldkey1,fieldkeyval1, callback) {
        request({
          url: '/validate/validateData',
          method: "post",
          data: {tablename, fieldid, checkfield, checkval: this.dac[checkfield], id: this.dac.dacid,fieldkey1,fieldkeyval1}
        }).then(res => {
          res === SUCCESS ? callback(Error(msg)) : callback()
        })
      },
      delUser (row) {
        let index = this.dacitems.findIndex(v => v.userid === row.userid)
        this.dacitems.splice(index, 1)
      },
      async getDptList () {
        this.dptList = await request({
          method: 'get',
          url: '/xtgl/dpt/getDptList',
          params: {comid: this.$store.getters.loginUser.usercomid}
        })
        this.dacdptList = this.dptList
      },
      async validateUsercode(rul, val, callback) {
        let res = await request({
          url: '/xtgl/dac/getDacList',
          method: "get",
          params: {comid: this.$store.getters.loginUser.comid, dacid: this.dac.dacid ? this.dac.dacid : 0, dacname: this.dac.dacname}
        })
        res.length ? callback(Error('名称已存在')) : callback()
      },
      async getDacItems() {
        this.dacitems = []
        let res = await request({
          url: '/xtgl/dac/getUserList',
          method: "get",
          params: {cosid:this.$store.getters.loginUser.cosid,comid: this.$store.getters.loginUser.comid, dacid: this.dac.dacid ? this.dac.dacid : 0}
        })
        this.dacitems = res
        this.dacitems = this.dacitems.map(v => {
          v.comchecked = Boolean(v.comchecked)
          v.dptchecked = Boolean(v.dptchecked)
          return v
        })
      },
      async getList() {
        this.query.comid = this.$store.getters.loginUser.comid
        let res = await request({
          url: '/xtgl/user/getPageList',
          method: "get",
          params: this.query
        })
        this.list = []
        if (this.dacitems.length) {
          if (res.list.length) {
            res.list.forEach(v => {
              let i = this.dacitems.findIndex(n => v.userid === n.userid)
              if (i < 0) {
                this.list.push(v)
              }
            })
          }
        } else {
          this.list = res.list
        }
      },
      async save () {
          if (!this.dacitems.length) {
            this.$message.warning('请添加用户！')
            return
          }
          this.dac.cosid = this.$store.getters.loginUser.cosid
          this.dac.daccomid = this.$store.getters.loginUser.comid
          this.dac.dacitems = this.dacitems
          this.submitForm('ruleForm').then(async() => {
            let data = await request({
              url: '/xtgl/dac/addOrEdit',
              method: "post",
              data: this.dac
          })
          if (data.issuccess === 1) {
            this.close()
            this.$message.success('保存成功')
          } else {
            this.$message.error('保存失败')
          }
        }).catch(() => {})
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'dacIndex'})
      },
      addUser () {
        this.query = {}
        this.dialogVisible = true
        this.getList()
      },
      submit () {
        if (!this.$refs.xGrid.selection.length) {
          this.$message.warning('请选择用户！')
          return
        }
        this.$refs.xGrid.selection.forEach(v => {
          this.dacitems.push({
            usercode: v.usercode,
            username: v.username,
            dptname: v.dptname,
            userid: v.userid,
            dptchecked: false,
            comchecked: false
          })
        })
        this.dacitems.length ? this.dacitems.sort((t1, t2) => t1.dptname - t2.dptname) : this.dacitems
        this.dialogVisible = false
      }
    }
  }
</script>


<style lang="scss" scoped>

  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .content .el-textarea__inner, .el-textarea, .el-input {
      width: 520px;
    }
    .file {
      display: flex;
      flex-direction: column;
      width: 50%;
    }
  }
</style>
